var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_vm._m(0),_c('div',{staticClass:"telegram-widget"},[_c('el-button',{attrs:{"type":"primary","round":""},on:{"click":_vm.verify}},[_vm._v("Увійти через телеграм")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page-logo"},[_c('img',{attrs:{"src":require("../../../public/img/logo.png")}})])
}]

export { render, staticRenderFns }